import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

/*
 * This component is built using `gatsby-plugin-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-plugin-image`: https://gatsbyjs.com/plugins/gatsby-plugin-image/
 * - `StaticQuery`: https://gatsby.dev/staticquery
 */

type ImageProps = {
  alt?: string
  imageName: string
  width: number | string
}

const Image: React.FC<ImageProps> = (props) => {
  const { alt = '', imageName, width } = props
  const query = graphql`
    query Images {
      images: allFile(filter: { extension: { regex: "/images/*.jpeg|jpg|png/" } }) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData(width: 700, quality: 100, layout: CONSTRAINED)
            }
          }
        }
      }
    }
  `

  const data = useStaticQuery(query)
  if (!imageName) {
    return null
  }

  const imgData = data.images.edges.find(
    (img: { node: { name: string } }) => img.node.name === imageName
  )
  return (
    <GatsbyImage alt={alt} style={{ width }} image={imgData.node.childImageSharp.gatsbyImageData} />
  )
}
export default Image
